import store from '../index';
import moment from 'moment';

const state = () => ({
  schemeStatusHeading: '',
  sortByOptions: [],
  general: [],
  showSchemes: true,
  showCalls: false,
  resultTypesString: '',
  showOpen: true,
  showForthcoming: true,
  showClosed: false,
  showDiscontinued: false,
  statusesString: '',
  pageCount: 0,
  numberOfResults: 0,
  currentPage: 1,
  searchText: '',
  audience: { options: [], label: '' },
  //This is just hidden for now, don't remove it:
  //industries: { options: [], label: '' },
  locations: { options: [], label: '' },
  purposes: { options: [], label: '' },
  schemeTypes: { options: [], label: '' },
  projectTypes: { options: [], label: '' },
  selectedAudiences: '',
  selectedLocations: '',
  //This is just hidden for now, don't remove it:
  // selectedIndustries: '',
  selectedPurposes: '',
  selectedSchemeTypes: '',
  selectedProjectTypes: '',
  searchIdentifier: '',
  searchAccronym: '',
  searchIntroduction: '',
  minBudget: null,
  maxBudget: null,
  organisationsInclude: [],
  organisationsExclude: [],
  startDate: '',
  endDate: '',
  organisationsIncludeString: '',
  organisationsExcludeString: '',
  locationsOptions: [{}],
  locationsSelectArray: [],
  locationsOptionsStrings: [],
  selectedLocationsStringsArray: [],
  activeFiltersCount: 0,
  selectedSort: 'Relevantie',
  daysRange: {
    from: '',
    to: '',
  },
  areFiltersChanged: true,
  applySavedSearchPause: false,
  isResetSearch: false,
  isApplyingFiltersReset: false,
  isSearchNewsWithSchemesFilters: false,
  displayNumberOfNewsResults: false,
  maxScoreOnCurrentPage: 0,
  maxScore: 0
});

const getters = {
  showAdvancedSearch: (state) => {
    return state.showAdvancedSearch;
  },
  getAllFilters: (state) => {
    return state.filterActivities;
  },

  getSchemeStatuses: (state) => {
    return state.schemeStatuses;
  },
};

const actions = {};

const mutations = {
  updateDisplayNumberOfNewsResults(state, val) {
    state.displayNumberOfNewsResults = val;
  },
  updateIsSearchNewsWithSchemesFilters(state, val) {
    state.isSearchNewsWithSchemesFilters = val;
  },

  updateIsApplyingFiltersReset(state, val) {
    state.isApplyingFiltersReset = val;
  },
  updateIsResetSearch(state, val) {
    state.isResetSearch = val;
  },
  updateapplySavedSearchPause(state, val) {
    state.applySavedSearchPause = val;
  },

  disableFiltersChange(state) {
    state.areFiltersChanged = false;
  },
  enableFiltersChange(state) {
    state.areFiltersChanged = true;
  },

  updateDaysRange(state, val) {
    state.daysRange.from = val.from;
    state.daysRange.to = val.to;
    state.startDate = val.from;
    state.endDate = val.to;

    store.commit('advancedSearch/updateActiveFiltersCount');
  },

  updateSelectedSort(state, value) {
    state.selectedSort = value;
  },

  updateActiveFiltersCount(state) {
    state.activeFiltersCount = 0;

    //This is just hidden for now, don't remove it:
    // if (state.selectedIndustries.length > 0) state.activeFiltersCount += 1;
    if (state.selectedAudiences.length > 0) state.activeFiltersCount += 1;
    if (state.selectedPurposes.length > 0) state.activeFiltersCount += 1;
    if (state.selectedLocations.length > 0) state.activeFiltersCount += 1;
    if (state.selectedSchemeTypes.length > 0) state.activeFiltersCount += 1;
    if (state.selectedProjectTypes.length > 0) state.activeFiltersCount += 1;
    if (state.statusesString.length > 0) state.activeFiltersCount += 1;
    if (
      (state.startDate != '' && state.startDate != null) ||
      (state.endDate != '' && state.endDate != null)
    )
      state.activeFiltersCount += 1;
    if (
      (state.minBudget != null && state.minBudget > 0) ||
      (state.maxBudget != null && state.maxBudget > 0)
    )
      state.activeFiltersCount += 1;

    if (
      /*    state.organisationsExclude &&
      (state.organisationsInclude.length > 0 ||
        state.organisationsExclude.length > 0) */
      (state.organisationsExclude && state.organisationsExclude.length) ||
      (state.organisationsInclude && state.organisationsInclude.length)
    )
      state.activeFiltersCount += 1;

    if (store.state.advancedFilters.sme || store.state.advancedFilters.notSme)
      state.activeFiltersCount += 1;

    if (
      store.state.advancedFilters.before ||
      store.state.advancedFilters.after ||
      store.state.advancedFilters.beforeAndAfter
    )
      state.activeFiltersCount += 1;

    if (
      store.state.advancedFilters.regional ||
      store.state.advancedFilters.national ||
      // store.state.advancedFilters.local ||
      store.state.advancedFilters.european
    )
      state.activeFiltersCount += 1;
  },

  clearSearchText(state) {
    state.searchText = '';
  },

  clearNewsletterFilters(state) {
    state.selectedLocations = '';
    state.selectedLocationsStringsArray = [];
    state.selectedAudiences = '';
    state.selectedPurposes = '';
    //This is just hidden for now, don't remove it:
    // state.selectedIndustries = '';
  },

  resetSearchFilter(state, clear) {
    state.searchText = '';
    state.minBudget = null;
    state.maxBudget = null;
    state.organisationsExclude = [];
    state.organisationsInclude = [];
    state.startDate = null;
    state.endDate = null;
    state.selectedSchemeTypes = '';
    state.selectedProjectTypes = '';
    /*   store.commit('advancedSearch/updateSelectedAudiences', []);
    store.commit('user/updateAudiencesPairs', []); */

    if (clear) {
      store.commit('advancedSearch/updateShowOpen', false);
      store.commit('advancedSearch/updateShowClosed', false);
      store.commit('advancedSearch/updateShowForthcoming', false);
      store.commit('advancedSearch/updateShowDiscontinued', false);
      /*   state.statusesString = ''; */
    } else {
      store.commit('advancedSearch/updateShowOpen', true);
      store.commit('advancedSearch/updateShowClosed', false);
      store.commit('advancedSearch/updateShowForthcoming', true);
      store.commit('advancedSearch/updateShowDiscontinued', false);
    }
    store.state.advancedFilters.sme = false;
    store.state.advancedFilters.notSme = false;
    store.state.advancedFilters.after = false;
    store.state.advancedFilters.before = false;
    store.state.advancedFilters.beforeAndAfter = false;
    store.state.advancedFilters.european = false;
    store.state.advancedFilters.regional = false;
    store.state.advancedFilters.national = false;

    // audiences, purposes, locations, industries
    //  if (clear) {
    state.selectedLocations = '';
    state.selectedLocationsStringsArray = [];
    state.selectedAudiences = '';
    state.selectedPurposes = '';
    //This is just hidden for now, don't remove it:
    // state.selectedIndustries = '';
    // }
  },
  fillFiltersWithSavedValues(state, val) {
    state.statusesString = val.statusses;
    if (!val.statusses.includes('Closed')) state.showClosed = false;
    else state.showClosed = true;

    if (!val.statusses.includes('Forthcoming')) state.showForthcoming = false;
    else state.showForthcoming = true;

    if (!val.statusses.includes('Open')) state.showOpen = false;
    else state.showOpen = true;

    if (!val.statusses.includes('Discontinued')) state.showDiscontinued = false;
    else state.showDiscontinued = true;
    state.minBudget = val.minAmount;
    state.maxBudget = val.maxAmount;
    state.startDate = val.callStartDate;
    state.endDate = val.callEndDate;
    state.daysRange.from =
      val.callStartDate == null
        ? null
        : moment(val.callStartDate).format('DD-MM-YYYY');
    state.daysRange.to =
      val.callEndDate == null
        ? null
        : moment(val.callEndDate).format('DD-MM-YYYY');
    state.startDate =
      val.callStartDate == null
        ? null
        : moment(val.callStartDate).format('DD-MM-YYYY');
    state.endDate =
      val.callEndDate == null
        ? null
        : moment(val.callEndDate).format('DD-MM-YYYY');
    state.searchText = val.term;
  },
  updateSelectedLocations(state, val) {
    state.locationsSelectArray = val;
    store.commit('advancedSearch/updateSelectedLocationsString');
    store.commit('advancedSearch/updateActiveFiltersCount');
  },

  updateSelectedLocationsStringArray(state, val) {
    state.selectedLocationsStringsArray = val;
    store.commit('advancedSearch/updateSelectedLocationsString');
  },

  updateSelectedLocationsString(state) {
    /*    if (!state.selectedLocations || state.selectedLocations == null) {
      state.selectedLocations = '';
      return;
    }
 */
    state.selectedLocations = '';

    if (state.locationsSelectArray && state.locationsSelectArray.length > 0) {
      for (let i = 0; i < state.locationsSelectArray.length; i++) {
        state.selectedLocations += state.locationsSelectArray[i].id + ',';
      }
      if (state.selectedLocations[state.selectedLocations.length - 1] == ',')
        state.selectedLocations = state.selectedLocations.substring(
          0,
          state.selectedLocations.length - 1
        );
    }

    store.commit('advancedSearch/updateActiveFiltersCount');
  },

  createLocationsOptions(state) {
    state.locationsOptions = [];
    for (let i = 0; i < state.locations.options.length; i++) {
      state.locationsOptions.push({
        id: state.locations.options[i].id,
        label: state.locations.options[i].label,
      });
      if (
        state.locations.options[i].children &&
        state.locations.options[i].children.length
      ) {
        for (let j = 0; j < state.locations.options[i].children.length; j++)
          state.locationsOptions.push({
            id: state.locations.options[i].children[j].id,
            label:
              /*      state.locations.options[i].children[j].label +
              ', ' +
              state.locations.options[i].label, */
              state.locations.options[i].label +
              ',' +
              state.locations.options[i].children[j].label,
            parent: state.locations.options[i],
            /*  state.locations.options[i].label +
              ',' +
              state.locations.options[i].children[j].label,
            */
          });
      }
    }
  },

  createLocationsOptionsString(state) {
    state.locationsOptionsStrings = [];
    for (let i = 0; i < state.locations.options.length; i++) {
      state.locationsOptionsStrings.push(state.locations.options[i].label);
      if (
        state.locations.options[i].children &&
        state.locations.options[i].children.length
      ) {
        for (let j = 0; j < state.locations.options[i].children.length; j++)
          state.locationsOptionsStrings.push(
            state.locations.options[i].children[j].label
          );
      }
    }
  },

  updateStartDate(state, val) {
    state.startDate = val;
    store.commit('advancedSearch/updateActiveFiltersCount');
  },
  updateEndDate(state, val) {
    state.endDate = val;
    store.commit('advancedSearch/updateActiveFiltersCount');
  },
  createOrganisationsIncludeString(state) {
    if (!state.organisationsInclude || state.organisationsInclude == null) {
      state.organisationsIncludeString = '';
      return;
    }
    state.organisationsIncludeString = '';
    if (state.organisationsInclude.length > 0) {
      for (let i = 0; i < state.organisationsInclude.length; i++) {
        state.organisationsIncludeString +=
          state.organisationsInclude[i].id + ',';
      }
      if (
        state.organisationsIncludeString[
          state.organisationsIncludeString.length - 1
        ] == ','
      )
        state.organisationsIncludeString = state.organisationsIncludeString.substring(
          0,
          state.organisationsIncludeString.length - 1
        );
    }
  },

  createOrganisationsExcludeString(state) {
    if (!state.organisationsExclude || state.organisationsExclude == null) {
      state.organisationsExcludeString = '';
      return;
    }
    state.organisationsExcludeString = '';

    if (state.organisationsExclude.length > 0) {
      for (let i = 0; i < state.organisationsExclude.length; i++) {
        state.organisationsExcludeString +=
          state.organisationsExclude[i].id + ',';
      }
      if (
        state.organisationsExcludeString[
          state.organisationsExcludeString.length - 1
        ] == ','
      )
        state.organisationsExcludeString = state.organisationsExcludeString.substring(
          0,
          state.organisationsExcludeString.length - 1
        );
    }
  },

  updateMinBudget(state, val) {
    state.minBudget = val;
    store.commit('advancedSearch/updateActiveFiltersCount');
  },
  updateMaxBudget(state, val) {
    state.maxBudget = val;
    store.commit('advancedSearch/updateActiveFiltersCount');
  },
  updateSearchIdentifier(state, val) {
    state.searchIdentifier = val;
  },
  updateSearchAccronym(state, val) {
    state.searchAccronym = val;
  },

  updateSearchIntroduction(state, val) {
    state.searchIntroduction = val;
  },

  updateOrganisationsExclude(state, val) {
    state.organisationsExclude = val;
    store.commit('advancedSearch/updateActiveFiltersCount');
  },

  updateOrganisationsInclude(state, val) {
    state.organisationsInclude = val;
    store.commit('advancedSearch/updateActiveFiltersCount');
  },

  /*   updateSelectedAudiences(state, val) {
    state.selectedAudiences = '';
    var audiences = state.audience.options;
    var toAdd = '';
    if (val.length > 0) {
      for (let i = 0; i < val.length; i++) {
        if (i != val.length - 1) state.selectedAudiences += val[i] + ',';
        else state.selectedAudiences += val[i];
      }
      for (let i = 0; i < audiences.length; i++) {
        if (audiences[i].children && audiences[i].children.length > 0) {
          var hasAllChildrenTicked = true;
          for (let j = 0; j < audiences[i].children.length; j++) {
            if (!val.includes(audiences[i].children[j].id)) {
              hasAllChildrenTicked = false;
              break;
            }
          }
          if (hasAllChildrenTicked) toAdd += ',' + audiences[i].id;
        }
      }
      if (toAdd != '' && toAdd.length > 0) state.selectedAudiences += toAdd;
    }

    var uniqueArr = state.selectedAudiences;
    uniqueArr = Array.from(new Set(uniqueArr.split(','))).toString();
    state.selectedAudiences = uniqueArr;

    store.commit('advancedSearch/updateActiveFiltersCount');
  }, */
  updateSelectedAudiences(state, val) {
    state.selectedAudiences = '';
    var audiences = state.audience.options;
    var toAdd = '';
    if (val.length > 0) {
      /*     for (let i = 0; i < val.length; i++) {
        if (i != val.length - 1) state.selectedPurposes += val[i] + ',';
        else state.selectedPurposes += val[i];
      }
 */
      for (let i = 0; i < audiences.length; i++) {
        if (audiences[i].children && audiences[i].children.length > 0) {
          var hasAllChildrenTicked = true;
          for (let j = 0; j < audiences[i].children.length; j++) {
            if (
              audiences[i].children[j].children &&
              audiences[i].children[j].children.length > 0
            ) {
              var hasAllSubChildrenTicked = true;
              for (
                let k = 0;
                k < audiences[i].children[j].children.length;
                k++
              ) {
                if (!val.includes(audiences[i].children[j].children[k].id)) {
                  hasAllSubChildrenTicked = false;
                  hasAllChildrenTicked = false;

                  let condition = true;
                  while (condition) {
                    let idx = val.indexOf(audiences[i].children[j].id);
                    if (idx > -1) val.splice(idx, 1);
                    else break;
                  }
                  state.selectedAudiences = state.selectedAudiences.replace(
                    audiences[i].children[j].id.toString(),
                    ''
                  );
                  state.selectedAudiences = state.selectedAudiences.replace(
                    audiences[i].children[j].id,
                    ''
                  );

                  break;
                }
              }
              if (
                hasAllSubChildrenTicked &&
                audiences[i].children[j].children &&
                audiences[i].children[j].children.length > 0
              ) {
                toAdd += ',' + audiences[i].children[j].id;
                val.push(audiences[i].children[j].id);
              }
            }

            if (!val.includes(audiences[i].children[j].id)) {
              hasAllChildrenTicked = false;
              continue;
            }
          }
          if (hasAllChildrenTicked) {
            toAdd += ',' + audiences[i].id;
          }
        }
      }
      /*       if (toAdd != '' && toAdd.length > 0) state.selectedPurposes += toAdd;
       */
    }

    for (let i = 0; i < val.length; i++) {
      if (i != val.length - 1) state.selectedAudiences += val[i] + ',';
      else state.selectedAudiences += val[i];
    }
    if (toAdd != '' && toAdd.length > 0) state.selectedAudiences += toAdd;

    var uniqueArr = state.selectedAudiences;
    uniqueArr = Array.from(new Set(uniqueArr.split(','))).toString();
    state.selectedAudiences = uniqueArr;

    if (state.selectedAudiences[state.selectedAudiences.length - 1] == ',')
      state.selectedAudiences = state.selectedAudiences.substring(
        0,
        state.selectedAudiences.length - 1
      );

    store.commit('advancedSearch/updateActiveFiltersCount');
  },
  //This is just hidden for now, don't remove it:
  /*
  updateSelectedIndustries(state, val) {
    state.selectedIndustries = '';
    var industries = state.industries.options;
    var toAdd = '';
    if (val.length > 0) {
      for (let i = 0; i < val.length; i++) {
        if (i != val.length - 1) state.selectedIndustries += val[i] + ',';
        else state.selectedIndustries += val[i];
      }
      for (let i = 0; i < industries.length; i++) {
        if (industries[i].children && industries[i].children.length > 0) {
          var hasAllChildrenTicked = true;
          for (let j = 0; j < industries[i].children.length; j++) {
            if (!val.includes(industries[i].children[j].id)) {
              hasAllChildrenTicked = false;
              break;
            }
          }
          if (hasAllChildrenTicked) toAdd += ',' + industries[i].id;
        }
      }
      if (toAdd != '' && toAdd.length > 0) state.selectedIndustries += toAdd;
    }

    var uniqueArr = state.selectedIndustries;
    uniqueArr = Array.from(new Set(uniqueArr.split(','))).toString();
    state.selectedIndustries = uniqueArr;
    store.commit('advancedSearch/updateActiveFiltersCount');
  },
  */
  /*   updateSelectedPurposes(state, val) {
    state.selectedPurposes = '';
    var purposes = state.purposes.options;
    var toAdd = '';
    if (val.length > 0) {
      for (let i = 0; i < val.length; i++) {
        if (i != val.length - 1) state.selectedPurposes += val[i] + ',';
        else state.selectedPurposes += val[i];
      }
      for (let i = 0; i < purposes.length; i++) {
        if (purposes[i].children && purposes[i].children.length > 0) {
          var hasAllChildrenTicked = true;
          for (let j = 0; j < purposes[i].children.length; j++) {
            if (!val.includes(purposes[i].children[j].id)) {
              hasAllChildrenTicked = false;
              break;
            }
          }
          if (hasAllChildrenTicked) toAdd += ',' + purposes[i].id;
        }
      }
      if (toAdd != '' && toAdd.length > 0) state.selectedPurposes += toAdd;
    }

    var uniqueArr = state.selectedPurposes;
    uniqueArr = Array.from(new Set(uniqueArr.split(','))).toString();
    state.selectedPurposes = uniqueArr;

    store.commit('advancedSearch/updateActiveFiltersCount');
  }, */
    updateSelectedPurposes(state, val) {
    state.selectedPurposes = '';
    var purposes = state.purposes.options;
    var toAdd = '';
    if (val.length > 0) {
      /*     for (let i = 0; i < val.length; i++) {
        if (i != val.length - 1) state.selectedPurposes += val[i] + ',';
        else state.selectedPurposes += val[i];
      }
 */
      for (let i = 0; i < purposes.length; i++) {
        if (purposes[i].children && purposes[i].children.length > 0) {
          var hasAllChildrenTicked = true;
          for (let j = 0; j < purposes[i].children.length; j++) {
            if (
              purposes[i].children[j].children &&
              purposes[i].children[j].children.length > 0
            ) {
              var hasAllSubChildrenTicked = true;
              for (
                let k = 0;
                k < purposes[i].children[j].children.length;
                k++
              ) {
                if (!val.includes(purposes[i].children[j].children[k].id)) {
                  hasAllSubChildrenTicked = false;
                  hasAllChildrenTicked = false;

                  let condition = true;
                  while (condition) {
                    let idx = val.indexOf(purposes[i].children[j].id);
                    if (idx > -1) val.splice(idx, 1);
                    else break;
                  }
                  state.selectedPurposes = state.selectedPurposes.replace(
                    purposes[i].children[j].id.toString(),
                    ''
                  );
                  state.selectedPurposes = state.selectedPurposes.replace(
                    purposes[i].children[j].id,
                    ''
                  );

                  break;
                }
              }
              if (
                hasAllSubChildrenTicked &&
                purposes[i].children[j].children &&
                purposes[i].children[j].children.length > 0
              ) {
                toAdd += ',' + purposes[i].children[j].id;
                val.push(purposes[i].children[j].id);
              }
            }

            if (!val.includes(purposes[i].children[j].id)) {
              hasAllChildrenTicked = false;
              continue;
            }
          }
          if (hasAllChildrenTicked) {
            toAdd += ',' + purposes[i].id;
          }
        }
      }
      /*       if (toAdd != '' && toAdd.length > 0) state.selectedPurposes += toAdd;
       */
    }

    for (let i = 0; i < val.length; i++) {
      if (i != val.length - 1) state.selectedPurposes += val[i] + ',';
      else state.selectedPurposes += val[i];
    }
    if (toAdd != '' && toAdd.length > 0) state.selectedPurposes += toAdd;

    var uniqueArr = state.selectedPurposes;
    uniqueArr = Array.from(new Set(uniqueArr.split(','))).toString();
    state.selectedPurposes = uniqueArr;

    if (state.selectedPurposes[state.selectedPurposes.length - 1] == ',')
      state.selectedPurposes = state.selectedPurposes.substring(
        0,
        state.selectedPurposes.length - 1
      );

    store.commit('advancedSearch/updateActiveFiltersCount');
  },
  updateSelectedSchemeTypes(state, val) {
    state.selectedSchemeTypes = '';
    var schemeTypes = state.schemeTypes.options;
    var toAdd = '';
    if (val.length > 0) {
      for (let i = 0; i < schemeTypes.length; i++) {
        if (schemeTypes[i].children && schemeTypes[i].children.length > 0) {
          var hasAllChildrenTicked = true;
          for (let j = 0; j < schemeTypes[i].children.length; j++) {
            if (
              schemeTypes[i].children[j].children &&
              schemeTypes[i].children[j].children.length > 0
            ) {
              var hasAllSubChildrenTicked = true;
              for (
                let k = 0;
                k < schemeTypes[i].children[j].children.length;
                k++
              ) {
                if (!val.includes(schemeTypes[i].children[j].children[k].id)) {
                  hasAllSubChildrenTicked = false;
                  hasAllChildrenTicked = false;

                  let condition = true;
                  while (condition) {
                    let idx = val.indexOf(schemeTypes[i].children[j].id);
                    if (idx > -1) val.splice(idx, 1);
                    else break;
                  }
                  state.selectedSchemeTypes = state.selectedSchemeTypes.replace(
                    schemeTypes[i].children[j].id.toString(),
                    ''
                  );
                  state.selectedSchemeTypes = state.selectedSchemeTypes.replace(
                    schemeTypes[i].children[j].id,
                    ''
                  );

                  break;
                }
              }
              if (
                hasAllSubChildrenTicked &&
                schemeTypes[i].children[j].children &&
                schemeTypes[i].children[j].children.length > 0
              ) {
                toAdd += ',' + schemeTypes[i].children[j].id;
                val.push(schemeTypes[i].children[j].id);
              }
            }

            if (!val.includes(schemeTypes[i].children[j].id)) {
              hasAllChildrenTicked = false;
              continue;
            }
          }
          if (hasAllChildrenTicked) {
            toAdd += ',' + schemeTypes[i].id;
          }
        }
      }
    }

    for (let i = 0; i < val.length; i++) {
      if (i != val.length - 1) state.selectedSchemeTypes += val[i] + ',';
      else state.selectedSchemeTypes += val[i];
    }
    if (toAdd != '' && toAdd.length > 0) state.selectedSchemeTypes += toAdd;

    var uniqueArr = state.selectedSchemeTypes;
    uniqueArr = Array.from(new Set(uniqueArr.split(','))).toString();
    state.selectedSchemeTypes = uniqueArr;

    if (state.selectedSchemeTypes[state.selectedSchemeTypes.length - 1] == ',')
      state.selectedSchemeTypes = state.selectedSchemeTypes.substring(
        0,
        state.selectedSchemeTypes.length - 1
      );
    store.commit('advancedSearch/updateActiveFiltersCount');
  },

  updateSelectedProjectTypes(state, val) {
    state.selectedProjectTypes = '';
    var projectTypes = state.projectTypes.options;
    var toAdd = '';
    if (val.length > 0) {
      for (let i = 0; i < projectTypes.length; i++) {
        if (projectTypes[i].children && projectTypes[i].children.length > 0) {
          var hasAllChildrenTicked = true;
          for (let j = 0; j < projectTypes[i].children.length; j++) {
            if (
              projectTypes[i].children[j].children &&
              projectTypes[i].children[j].children.length > 0
            ) {
              var hasAllSubChildrenTicked = true;
              for (
                let k = 0;
                k < projectTypes[i].children[j].children.length;
                k++
              ) {
                if (!val.includes(projectTypes[i].children[j].children[k].id)) {
                  hasAllSubChildrenTicked = false;
                  hasAllChildrenTicked = false;

                  let condition = true;
                  while (condition) {
                    let idx = val.indexOf(projectTypes[i].children[j].id);
                    if (idx > -1) val.splice(idx, 1);
                    else break;
                  }
                  state.selectedProjectTypes = state.selectedProjectTypes.replace(
                    projectTypes[i].children[j].id.toString(),
                    ''
                  );
                  state.selectedProjectTypes = state.selectedProjectTypes.replace(
                    projectTypes[i].children[j].id,
                    ''
                  );

                  break;
                }
              }
              if (
                hasAllSubChildrenTicked &&
                projectTypes[i].children[j].children &&
                projectTypes[i].children[j].children.length > 0
              ) {
                toAdd += ',' + projectTypes[i].children[j].id;
                val.push(projectTypes[i].children[j].id);
              }
            }

            if (!val.includes(projectTypes[i].children[j].id)) {
              hasAllChildrenTicked = false;
              continue;
            }
          }
          if (hasAllChildrenTicked) {
            toAdd += ',' + projectTypes[i].id;
          }
        }
      }
    }

    for (let i = 0; i < val.length; i++) {
      if (i != val.length - 1) state.selectedProjectTypes += val[i] + ',';
      else state.selectedProjectTypes += val[i];
    }
    if (toAdd != '' && toAdd.length > 0) state.selectedProjectTypes += toAdd;

    var uniqueArr = state.selectedProjectTypes;
    uniqueArr = Array.from(new Set(uniqueArr.split(','))).toString();
    state.selectedProjectTypes = uniqueArr;

    if (
      state.selectedProjectTypes[state.selectedProjectTypes.length - 1] == ','
    )
      state.selectedProjectTypes = state.selectedProjectTypes.substring(
        0,
        state.selectedProjectTypes.length - 1
      );

    store.commit('advancedSearch/updateActiveFiltersCount');
  },
  updateSearchText(state, val) {
    state.searchText = val;
    state.selectedSort = 'Relevantie';
  },

  updatePageCount(state, val) {
    state.pageCount = val;
  },

  updateResultsCount(state, val) {
    state.numberOfResults = val;
  },

  updateMaxScoreOnCurrentPage(state) {
    var maxScore = Math.max.apply(null, store.state.grantItems.grants.map(g => g.score));
    state.maxScoreOnCurrentPage = maxScore;
  },

  updateMaxScore(state, val) {
    state.maxScore = val;
  },

  updateCurrentPage(state, val) {
    state.currentPage = val;
  },

  updateShowSchemes(state, value) {
    state.showSchemes = value;
  },
  updateShowCalls(state, value) {
    state.showCalls = value;
  },
  updateShowOpen(state, value) {
    state.showOpen = value;
    store.commit('advancedSearch/createStatusesString');
  },
  updateShowClosed(state, value) {
    state.showClosed = value;
    store.commit('advancedSearch/createStatusesString');
  },
  updateShowForthcoming(state, value) {
    state.showForthcoming = value;
    store.commit('advancedSearch/createStatusesString');
  },
  updateShowDiscontinued(state, value) {
    state.showDiscontinued = value;
    store.commit('advancedSearch/createStatusesString');
  },

  createStatusesString(state) {
    state.statusesString = '';
    if (state.showOpen) state.statusesString += 'Open,';
    if (state.showForthcoming) state.statusesString += 'Forthcoming,';
    if (state.showClosed) state.statusesString += 'Closed,';
    if (state.showDiscontinued) state.statusesString += 'Discontinued,';
    state.statusesString.split(' ').join(';');

    store.commit('advancedSearch/updateActiveFiltersCount');
  },

  createResultTypesString(state) {
    state.resultTypesString = '';
    if (state.showSchemes && state.showCalls) state.resultTypesString = '0, 1';
    if (state.showSchemes && !state.showCalls) state.resultTypesString = '0';
    if (!state.showSchemes && state.showCalls) state.resultTypesString = '1';
  },

  toggleAdvancedSearch(state) {
    state.showAdvancedSearch = !state.showAdvancedSearch;
  },
  updateMinAmount(state, amount) {
    state.selectedMinAmount = amount;
  },
  updateMaxAmount(state, amount) {
    state.selectedMaxAmount = amount;
  },
  updateSelectedDate(state, date) {
    state.selectedEndDate = date;
  },

  updateFilterActivities(state, activities) {
    state.general = activities;
    state.audience = activities.audience;
    //This is just hidden for now, don't remove it:
    //state.industries = activities.industries;
    state.locations = activities.locations;
    state.purposes = activities.purposes;
    state.schemeTypes = activities.schemeTypes;
    state.projectTypes = activities.projectTypes;
  },

  updateCheckedContributionType(state, newData) {
    state.contributionTypeOptions.options = newData;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
